import React from 'react'

const References  = () => {
    return (
        <>

{/* References container start */}
<div className="flex flex-wrap lg:flex-nowrap items-center mb-20">
                {/* References container start */}
                <div className="w-full">
                    <ol className="list-decimal pl-6 space-y-4">
                        <li className="text-sm 2xl:text-base text-red-primary font-bold">
                            <p className = "font-normal feature-p-text pl-3 ">Hartrumpf M. et al. </p>
                            <p className = "feature-p-text   pl-3 ">
                            Favorable gradients with the mitroflow aortic valve prosthesis in everyday surgery.</p>
                            <p className = "font-normal italic feature-p-text  pl-3 ">Thorac Cardiovasc Surg. 2012 Jul;60(5):326-33; discussion 333-4.</p>
                        </li>
                        <li className="text-sm 2xl:text-base text-red-primary font-bold">
                            <p className = "font-normal feature-p-text  pl-3 ">
                            von Knobelsdorff-Brenkenhoff F. et al. </p>
                            <p className = "feature-p-text   pl-3 ">
                            In vitro assessment of heart valve bioprostheses by cardiovascular
                             magnetic resonance: four-dimensional mapping of flow patterns and orifice area planimetry.</p>
                            <p className = "font-normal italic feature-p-text  pl-3 ">
                            Eur J Cardiothorac Surg. 2011 Sep;40(3):736-42.</p>
                        </li>
                        <li className="text-sm 2xl:text-base text-red-primary font-bold">
                            <p className = "font-normal feature-p-text  pl-3  ">
                            Jamieson WR. et al.</p>
                            <p className = "feature-p-text   pl-3 ">
                            Hemodynamic performance of mitroflow aortic pericardial bioprosthesis-optimizing 
                            management for the small aortic annulus.</p>
                            <p className = "font-normal italic feature-p-text  pl-3 ">
                            Thorac Cardiovasc Surg. 2010 Mar;58(2):69-75.</p>
                        </li>
                        <li className="text-sm 2xl:text-base text-red-primary font-bold">
                            <p className = "font-normal feature-p-text  pl-3  ">
                            Yankah CA. et al.</p>
                            <p className = "feature-p-text   pl-3 ">
                            Seventeen-year clinical results of 1,037 Mitroflow pericardial heart valve prostheses in the aortic position.</p>
                            <p className = "font-normal italic feature-p-text  pl-3 ">
                            J Heart Valve Dis. 2005 Mar;14(2):172-9; discussion 179-80.</p>
                        </li>
                        <li className="text-sm 2xl:text-base text-red-primary font-bold">
                            <p className = "font-normal feature-p-text  pl-3 ">Conte J. et al. </p>
                            <p className = "feature-p-text   pl-3 ">
                            A North American, prospective, multicenter assessment of the 
                            Mitroflow aortic pericardial prosthesis.</p>
                            <p className = "font-normal italic feature-p-text  pl-3 ">
                            Ann Thorac Surg. 2010 Jul;90(1):144-152.</p>
                        </li>
                        <li className="text-sm 2xl:text-base text-red-primary font-bold">
                            <p className = "font-normal feature-p-text  pl-3 ">Ugur M. et al. </p>
                            <p className = "feature-p-text   pl-3 ">
                            Comparison of early hemodynamic performance of 3 aortic valvebioprostheses</p>
                            <p className = "font-normal italic feature-p-text  pl-3 ">
                            J Thorac Cardiovasc Surg. 2014 Jan 15. pii: S0022-5223(14)00027-0.</p>
                        </li>
                        <p className = "feature-p-text font-bold">
                            Technical claims supported by CORCYM data on file. 
                        </p>
                            
                    </ol>
                    
                </div>
                {/* feature text container end */}
            </div>
            {/* feature container end */}

        </>
    )
}

export default References 

